import { apiGet, apiPost } from "./helpers/api";
import { normalize, schema } from "normalizr";
import { fetchMock } from "./mockProccess";

const answer = new schema.Entity("answers");

// A 422 on answer creation means a near-simultaneous double-submit already
// persisted this answer (the first request returns 201, the second hits the
// uniqueness validation). The student's answer is saved, so we swallow the
// conflict and just resync the mock. Any other error is re-thrown so real
// failures stay visible (and reported to Bugsnag).
const handleMockAnswerError = (error, dispatch, mockId, skipMockFetch) => {
  const status = error?.status ?? error?.response?.status;

  if (status === 422) {
    !skipMockFetch && fetchMock(dispatch, mockId);
    return;
  }

  throw error;
};

export const fetchAnswers = (dispatch, mockId) => {
  apiGet(`/api/v1/mocks/${mockId}/answers`).then((response) => {
    dispatch({
      type: "ANSWERS_FETCHED",
      ...normalize(response.body.data, new schema.Array(answer)),
    });
  });
};

export const createLessonAnswer = (dispatch, lesson, replyId) => {
  return apiPost(`/api/v1/courses/${lesson.courseId}/lessons/${lesson?.id}/answers`)
    .send({
      answer: {
        courseId: lesson?.courseId,
        lessonId: lesson?.id,
        questionId: lesson?.meta?.question,
        replyId,
      },
    })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
    });
};

export const createLessonAnswerV2 = (
  dispatch,
  lesson,
  questionId,
  questionStemId,
  choiceId
) => {
  return apiPost(`/api/v1/courses/${lesson.courseId}/lessons/${lesson?.id}/answers`)
    .send({
      answer: {
        courseId: lesson?.courseId,
        lessonId: lesson?.id,
        questionId,
        questionStemId,
        choiceId,
      },
    })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
    });
};

export const createMockAnswer = (
  dispatch,
  courseId,
  mockId,
  questionId,
  replyId,
  skipMockFetch = false
) => {
  return apiPost(`/api/v1/mocks/${mockId}/answers`)
    .send({ answer: { courseId, mockId, questionId, replyId } })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
      /* skipMockFetch is needed until api/v1/mock_serializer.rb line 12
       (hotfix app not showing the results) is not fixed */
      !skipMockFetch && fetchMock(dispatch, mockId);
    })
    .catch((error) => handleMockAnswerError(error, dispatch, mockId, skipMockFetch));
};

export const createMockAnswerV2 = (
  dispatch,
  courseId,
  mockId,
  questionId,
  questionStemId,
  choiceId,
  skipMockFetch = false
) => {
  return apiPost(`/api/v1/mocks/${mockId}/answers`)
    .send({
      answer: {
        courseId,
        mockId,
        questionId,
        questionStemId,
        choiceId,
      },
    })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
      /* skipMockFetch is needed until api/v1/mock_serializer.rb line 12
       (hotfix app not showing the results) is not fixed */
      !skipMockFetch && fetchMock(dispatch, mockId);
    })
    .catch((error) => handleMockAnswerError(error, dispatch, mockId, skipMockFetch));
};

export const createMockInteractiveAnswer = (
  dispatch,
  courseId,
  mockId,
  questionId,
  questionPromptId,
  questionPromptAlternativeId,
  skipMockFetch = false
) => {
  return apiPost(`/api/v1/mocks/${mockId}/answers`)
    .send({
      answer: {
        courseId,
        mockId,
        questionId,
        questionPromptId,
        questionPromptAlternativeId,
      },
    })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
      !skipMockFetch && fetchMock(dispatch, mockId);
    })
    .catch((error) => handleMockAnswerError(error, dispatch, mockId, skipMockFetch));
};

export const fetchLessonAnswers = (dispatch, courseId, lessonId) => {
  dispatch({ type: "ANSWERS_FETCH_REQUESTED" });
  apiGet(`/api/v1/courses/${courseId}/lessons/${lessonId}/answers`).then(
    (response) =>
      dispatch({
        type: "LESSON_ANSWER_FETCHED",
        ...normalize(response.body.data, new schema.Array(answer)),
      })
  );
};

export const createLessonInteractiveAnswer = (
  dispatch,
  lesson,
  questionId,
  questionPromptId,
  questionPromptAlternativeId
) => {
  return apiPost(`/api/v1/courses/${lesson.courseId}/lessons/${lesson?.id}/answers`)
    .send({
      answer: {
        courseId: lesson?.courseId,
        lessonId: lesson?.id,
        questionId,
        questionPromptId,
        questionPromptAlternativeId,
      },
    })
    .then((response) => {
      dispatch({
        type: "ANSWER_CREATED",
        ...normalize(response.body.data, answer),
      });
    });
};
